import { CmsObject } from 'entities/cms';

export type ContentSection = {
  fields: {
    reference: CmsObject[];
    title: string;
  };
};

export type GetContentSectionProps = {
  data: {
    section?: ContentSection[];
    heroSection?: ContentSection;
  };
  include?: string;
  exclude?: string[];
};

export const getContentSection = ({
  data,
  include,
  exclude,
}: GetContentSectionProps) => {
  let res = data?.section || null;
  if (!res) {
    res = data?.heroSection && [data?.heroSection];
  }

  if (include) {
    res = res?.filter((v) => include.indexOf(v?.fields?.title) >= 0) || null;
    return res;
  }

  if (exclude) {
    res = res?.filter((v) => exclude.indexOf(v?.fields?.title) < 0) || null;
    return res;
  }

  return res;
};
